import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnergy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.00039 7.99998H12.0004L8.00039 15L9.00039 9.99998H6.00039L10.0004 2.99998L9.00039 7.99998Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.29336 0.707011C8.65939 0.341267 9.23858 0.317687 9.63125 0.637675L9.70742 0.707011L17.2934 8.29295L17.3617 8.36814C17.6822 8.76092 17.6595 9.34182 17.2934 9.70799L9.70742 17.2939L9.63125 17.3613C9.26461 17.6605 8.7352 17.6605 8.36856 17.3613L8.29336 17.2939L0.706447 9.70799L0.638087 9.63084C0.339357 9.26421 0.339051 8.73461 0.638087 8.36814L0.706447 8.29295L8.29336 0.707011ZM1.41348 8.99998L8.99942 16.5859L16.5863 8.99998L9.00039 1.41404L1.41348 8.99998Z",
		fill: "black"
	})]
});
export default SvgEnergy;
